import { countryCodeToFlag } from '@/lib/channels';

interface FlagIconProps {
  code: string;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

const SIZES = {
  sm: 'text-base',
  md: 'text-xl',
  lg: 'text-3xl',
};

export function FlagIcon({ code, className = '', size = 'md' }: FlagIconProps) {
  return (
    <span
      className={`inline-block leading-none ${SIZES[size]} ${className}`}
      role="img"
      aria-label={code}
    >
      {countryCodeToFlag(code)}
    </span>
  );
}